import React from 'react';

import { connect } from 'react-redux';
import { BaseStore } from 'src/store';
import { LayoutPage, LayoutBlockText } from 'src/modules/layout';
import { getJobTypeRow, getJobDateRow, getJobLocationRow } from 'src/modules/jobs';
import { JobsDetailsStore } from '../../store/types';
import { useIntl } from 'react-intl';
import { useLocale } from 'src/modules/locale';
// import styles from './JobsDetailsPage.module.scss';

interface JobsDetailsPageProps extends JobsDetailsStore {}

const JobsDetailsPage: React.FunctionComponent<JobsDetailsPageProps> = (props) => {
  const intl = useIntl();
  const { getLocalizedObject, locale } = useLocale();
  const { title, slug, description, city, type, start_date } = getLocalizedObject(props).job || {};

  const pageProperties = {
    title: intl.formatMessage({ id: 'page/careers/listing/head/page_title' }),
    description: intl.formatMessage({ id: 'page/careers/listing/head/meta_description' }),
    breadcrumbs: [
      {
        title: intl.formatMessage({
          id: 'breadcrumbs/careers',
        }),
        as: '/about/careers',
        href: '/about/careers',
      },
      {
        title,
        href: '/about/careers/[slug]',
        as: `/about/careers/${encodeURIComponent(slug)}`,
      },
    ],
  };

  return (
    <LayoutPage {...pageProperties}>
      <LayoutBlockText
        title={title}
        caption={
          <div>
            <div>{getJobLocationRow(city, intl)}</div>
            <div>{getJobTypeRow(type, intl)}</div>
            <div>{getJobDateRow(start_date, locale, intl)}</div>
          </div>
        }
        body_text={description}
      />
    </LayoutPage>
  );
};

const mapStateToProps = (state: BaseStore) => {
  return { ...state.jobs.details };
};

export default connect(mapStateToProps)(JobsDetailsPage);
